import useSWR from 'swr'
import { APIDecoratorWithBaseURI } from '../../Service/api'
import { AxiosResponse } from 'axios'
import { useMemo } from 'react'

export type SentCourtesyProps = {
  id: number
  name: string
  cpf: string
  email: string
  courtesy_day: string
  courtesy_time: string
  voucher: string
}

export interface TrackerResponse {
  sentCourtesies: {
    total_pages: number
    data: SentCourtesyProps[]
  }
  sentCourtesiesLoading: boolean
  sentCourtesiesError: string | null
}

export const useGetCourtesiesList = (
  eventId: string,
  page: string
): TrackerResponse => {
  const url = `/producer/app/v2/pdv/courtesies?event_id=${eventId}&page=${page}`
  const fetchData = async (): Promise<AxiosResponse> => {
    return await APIDecoratorWithBaseURI().get(url)
  }

  const { data, error, isLoading } = useSWR<any>(url, fetchData)

  const nestedData = useMemo(() => data?.data.data || undefined, [data])

  const memoizedValue = useMemo(
    () => ({
      sentCourtesies: nestedData,
      sentCourtesiesLoading: isLoading,
      sentCourtesiesError: error,
    }),
    [nestedData, error, isLoading]
  )

  return memoizedValue
}
